import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695ae4cd7683ed00143500cf/one_solar_energy/src/app/landing-page/components/LandingPageInteractive.tsx");
